<style lang="scss" scoped>
.destory-update {
    position: relative;
}
.attach-container {
    padding: 20px 40px;
}
.footer-button {
    margin: 0 5px;
}
.modal-desc {
    padding: 20px 0;
    text-align: center;
    font-size: 14px;
}
.modal-button {
    float: right;
}
</style>
<template>
    <div class="destory-update">
        <compWrapper theme="primary" title="基础信息">
            <compFormQuery
                v-if="queryType === 'query'"
                class="margin-layout"
                :formdata="getBase"
                :value="baseInfo"
            ></compFormQuery>
            <compFormEdit
                v-else
                ref="formbase"
                class="margin-layout"
                :formdata="getBase"
                v-model="baseInfo"
            ></compFormEdit>
            <!-- <Form class="clearfix margin-top-15" refs="baseForm" :labelWidth="120" :model="baseInfo">
                <Col span="12">
                    <FormItem label="销毁仓库" prop="destoryWarehouse" :rules="required">
                        <div v-if="queryType === 'query'" class="font-weight">{{getCommonSelectValue(warehouseList, baseInfo.destoryWarehouse)}}</div>
                        <Select v-else v-model="baseInfo.destoryWarehouse">
                            <Option v-for="item in warehouseList" :key="item.key" :value="item.value">{{item.label}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="项目" prop="productId" :rules="required">
                        <div v-if="queryType === 'query'" class="font-weight">{{getCommonSelectValue(productList, baseInfo.productId)}}</div>
                        <Select v-else v-model="baseInfo.productId">
                            <Option v-for="item in productList" :key="item.key" :value="item.value">{{item.label}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="来源单号">
                        <div v-if="queryType === 'query'" class="font-weight">{{baseInfo.orderNo || '--'}}</div>
                        <Input v-else v-model="baseInfo.orderNo"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="库存类型">
                        <div v-if="queryType === 'query'" class="font-weight">{{getCommonSelectValue(stockTypeList, baseInfo.stockType)}}</div>
                        <Select v-else v-model="baseInfo.stockType">
                            <Option v-for="item in stockTypeList" :key="item.key" :value="item.value">{{item.label}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="期望销毁日期" prop="destoryDate" :rules="required">
                        <div v-if="queryType === 'query'" class="font-weight">{{baseInfo.destoryDate || '--'}}</div>
                        <Input v-else v-model="baseInfo.orderNo"></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="备注">
                        <div v-if="queryType === 'query'" class="font-weight">{{baseInfo.info || '--'}}</div>
                        <Input v-else type="textarea" v-model="baseInfo.info"></Input>
                    </FormItem>
                </Col>
            </Form>-->
            <slot name="footer" slot="footer" class="zindex-up">
                <Button
                    v-if="baseInfo.status === 2"
                    class="footer-button"
                    @click="pushAgain"
                    type="info"
                    >重推仓库</Button
                >
                <Button
                    v-if="baseInfo.status === 1 && manage !== 1"
                    class="footer-button"
                    type="warning"
                    @click="handleOperate(3)"
                    >撤销审核</Button
                >
                <Button
                    v-if="baseInfo.status === 1 && manage === 1 && handleAuth('fbb.destroyPlanOrder.audit')"
                    class="footer-button"
                    type="warning"
                    @click="handleOperate(4)"
                    >审核</Button
                >
                <Button
                    v-if="
                        (queryType !== 'query' && baseInfo.status === 0) ||
                        queryType === 'add'
                    "
                    class="footer-button"
                    type="info"
                    @click="update"
                    >保存为草稿</Button
                >
                <Button
                    v-if="
                        baseInfo.status === 0 ||
                        baseInfo.status === 3 ||
                        queryType === 'add'
                    "
                    class="footer-button"
                    type="success"
                    @click="handleOperate(2)"
                    >提交审核</Button
                >
                <Button
                    v-if="baseInfo.status <= 1 && queryType === 'query'"
                    class="footer-button"
                    type="error"
                    @click="handleOperate(10)"
                    >取消</Button
                >
                <Button
                    v-if="manage == 1 && baseInfo.status === 4 && handleAuth('fbb.destroyPlanOrder.complete')"
                    class="footer-button"
                    type="success"
                    @click="handleOperate(5)"
                    >完成</Button
                >
                <Button class="footer-button" @click="cancel">返回</Button>
            </slot>
        </compWrapper>
        <compWrapper theme="info" title="产品信息">
            <Form
                v-if="queryType !== 'query'"
                ref="productForm"
                class="clearfix margin-top-15"
                :model="productInfo"
                :labelWidth="110"
                :rules="formRules"
            >
                <Row>
                    <Col span="6">
                        <FormItem
                            label="SKU"
                            v-if="type !== 'query'"
                            prop="sku"
                        >
                            <!-- <Input v-model="baseInfo.sku"></Input> -->
                            <!-- <vInput
                                v-model="productInfo.sku"
                                readonly
                                suffix="search"
                                @on-icon-click="handleSkuErp"
                            ></vInput> -->
                            <Input
                                v-model="productInfo.sku"
                                readonly
                            >
                                <Icon style="cursor: pointer;" @click="handleSkuErp" type="ios-search" slot="suffix" />
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="可用库存">
                            <div class="font-weight">
                                {{ productInfo.inventoryAvailable }}
                            </div>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem
                            label="销毁数量"
                            prop="destroyQty"
                        >
                            <vInputNumber v-model="productInfo.destroyQty"></vInputNumber>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <Button
                            class="margin-left-50"
                            type="primary"
                            @click="addProductList()"
                            >添加</Button
                        >
                        <Button
                            class="margin-left-10"
                            type="info"
                            @click="importFile"
                            >导入</Button
                        >
                    </Col>
                </Row>
            </Form>
            <div class="table-container">
                <div class="margin-left-40" v-if="queryType !== 'query'">
                    <Button type="default" @click="deleteOne">删除</Button>
                    <Button
                        class="margin-left-10"
                        type="default"
                        @click="deleteAll"
                        >清空</Button
                    >
                </div>
                <div class="total-count clearfix" style="margin: 20px 40px">
                    <Row>
                        <Col span="8">
                            <div>
                                产品总数量
                                <span class="margin-left-10 font-weight">{{
                                    productCount.totalCount
                                }}</span>
                            </div>
                        </Col>
                        <Col span="8">
                            <div>
                                产品总体积(CBM)
                                <span class="margin-left-10 font-weight">{{
                                    productCount.totalVolume
                                }}</span>
                            </div>
                        </Col>
                        <Col span="8">
                            <div>
                                产品总重量(kg)
                                <span class="margin-left-10 font-weight">{{
                                    productCount.totalWeight
                                }}</span>
                            </div>
                        </Col>
                    </Row>
                </div>
                <Table
                    class="margin-left-40 margin-right-40"
                    :columns="productColumn"
                    :data="productList"
                    @on-selection-change="selectChange"
                ></Table>
            </div>
        </compWrapper>
        <!-- <compWrapper theme="primary" title="附件信息">
            <div class="attach-container">
                <div class="button-container">
                    <Button v-if="baseInfo.status < 4" type="success" @click="addAttach">添加</Button>
                    <Button v-if="baseInfo.status < 4"
                        class="margin-left-10"
                        type="default"
                        @click="delAttach"
                        >删除</Button
                    >
                    <Button
                        v-if="type === 'query' && baseInfo.status === 2"
                        class="margin-left-10"
                        type="info"
                        >附件重推</Button
                    >
                </div>
                <Table
                    class="margin-top-15"
                    :columns="attachColumn"
                    :data="attachList"
                    @on-selection-change="changeSelection"
                ></Table>
            </div>
        </compWrapper> -->
        <compWrapper v-if="queryType === 'query'" theme="gray" title="操作历史">
            <Table :columns="logColumn" :data="logList"></Table>
        </compWrapper>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show = false"
            @on-confirm="modalProps.show = false"
        >
            <div class="clearfix" v-if="modalProps.showConfirm">
                <div class="modal-desc">{{ modalProps.desc }}</div>
                <div class="modal-button">
                    <Button
                        class="margin-right-15"
                        type="primary"
                        @click="modalProps.confirm"
                        >确定</Button
                    >
                    <Button type="default" @click="modalProps.show = false"
                        >取消</Button
                    >
                </div>
            </div>
            <component
                v-if="modalProps.component"
                :is="modalProps.component"
                v-bind="modalProps.props"
                @on-close="modalProps.show = false"
                @on-success="modalSuccess"
                v-on="modalProps.on"
            />
        </compModal>
        <Spin v-if="loading" fix size="large"></Spin>
    </div>
</template>

<script>
import compErpsku from "./erpsku.js";
import compUpload from "./upload.vue";
import compSubmit from "./../../submit.vue";
import mixin from "./../mixin";
import { mapState, mapGetters } from "vuex";
import {
    HttpGetcalculateWeightAndVolume,
    HttpDelAttachments,
    HttpGetProductsOne,
    HttpCreateDestoryPlan,
    HttpGetDestoryPlanOne,
    HttpGetDestoryPlanProductList,
    HttpGetDestoryLog,
    HttpUpdateDesotryPlan,
    HttpGetAttachList,
    HttpDestoryPlanSubmit,
    HttpDestoryPlanCancelCommit,
    HttpPlanBillErpSku,
    HttpPushWarehouse
} from "@/service/destory";
export default {
    props: ["type", "id", "isManage"],
    mixins: [mixin],
    components: {
        compErpsku,
        compUpload,
        compSubmit,
    },
    data() {
        return {
            manage: this.isManage ? this.isManage : this.$route.query.isManage,
            queryType: this.type ? this.type : this.$route.params.type,
            orderId: this.id ? this.id : this.$route.query.id,
            baseInfo: {},
            productInfo: {},
            productCount: {
                totalCount: 0,
                totalVolume: 0,
                totalWeight: 0,
            },
            productList: [],
            selectedIndex: [],
            attachList: [],
            required: {
                required: true,
                message: "请填写必填项",
            },
            modalProps: {
                show: false,
                formdata: null,
            },
            attachSelection: [],
            logList: [],
            loading: true,
        };
    },
    watch: {
        productList: {
            // deep: true,
            handler(val) {
                // console.log("改变了", val);
                this.updateProductList();
            },
        },
    },
    created() {
        if (this.queryType === "query" || this.queryType === "edit") {
            this.getDetail();
        } else {
            this.loading = false;
        }
    },
    computed: {
        ...mapGetters("dictionary", [
            "getProductList",
            "getFilterDisabledWarehouse",
            "getFilterDisabledWarehouse",
            "getBillcusWareList",
            "getCusproductList",
        ]),
        isQuery(){
            return this.queryType === "query"
        },
        formRules () {
            return {
                sku: [
                    {
                        required: true,
                        message: '该信息不能为空'
                    },
                ],
                destroyQty: [
                    {
                        required: true,
                        message: '该信息不能为空'
                    },
                    {
                        trigger: "blur",
                        validator: (rule, value = "", callback) => {
                            if (
                                /[0-9]/g.test(
                                    value
                                )
                            ) {
                                callback();
                            } else {
                                callback(
                                    new Error('请输入数字')
                                );
                            }
                        },
                    },
                ]
            }
        },
        getFileProps() {
            return {
                action:
                    process.env.VUE_APP_APIURL_FBB+
                    "/api/v2/destroyPlanOrderItem/importItems",
                name: "excelFile",
                data: {
                    lineId: this.baseInfo.lineId?this.baseInfo.lineId:0
                },
                multiple: false,
                download: () =>{
                    this.handleWebfs("/static/template/destory_plan_order.xlsx", {}, {
                        executor: 'download',
                        type: 'url'
                    });
                },
                formatter: (res, item) => {
                    return res.data;
                },
                // format: this.formData.format
            };
        },
        getBase() {
            return [
                {
                    label: "销毁计划单号",
                    key: "destroyPlanOrderNo",
                    show: this.queryType === "query",
                },
                {
                    label: "状态",
                    key: "status",
                    options: this.statusList,
                    show: this.queryType === "query",
                },
                {
                    label: "销毁仓库",
                    key:
                        this.manage === 1
                            ? "orgWarehouseName"
                            : "orgWarehouseId",
                    tag: this.manage === 1 ? "vInput" : "vSelect",
                    options: this.getFilterDisabledWarehouse,
                    required: true,
                    props: {
                        filterable: true,
                    },
                    on: {
                        "on-change": (val) => {
                            if (!val) return;
                            this.baseInfo.orgWarehouseCode = this.getFilterDisabledWarehouse.filter(
                                (item) => {
                                    return item.value === val;
                                }
                            )[0].label;
                        },
                    },
                },
                {
                    label: "项目",
                    key: (this.manage === 1 || this.isQuery) ? "lineName" : "lineId",
                    tag: this.manage === 1 ? "vInput" : "vSelect",
                    options: this.getProductList,
                    required: false,
                    props: {
                        filterable: true,
                    },
                    on: {
                        "on-change": (val) => {
                            if (!val) return;
                            this.baseInfo.lineName = this.getProductList.filter(
                                (item) => {
                                    return item.value === val;
                                }
                            )[0].label;
                        },
                    },
                },
                {
                    label: "来源单号",
                    key: "sourceNo",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: "库存类型",
                    key: "inventoryType",
                    tag: "vSelect",
                    options: this.stockTypeList,
                    required: true,
                },
                {
                    label: "期望销毁日期",
                    key: "hopeDestroyData",
                    tag: "vDatepicker",
                    props: {
                        type: "date",
                    },
                    required: true,
                },
                {
                    label: "备注",
                    key: "remark",
                    tag: "vTextarea",
                    required: false,
                },
            ];
        },
        productColumn() {
            let columns = [
                {
                    type: "index",
                    title: "No.",
                    width: 60,
                    align: "center",
                },
                {
                    title: "SKU",
                    key: "sku",
                },
                {
                    title: "产品名称",
                    key: "productName",
                },
                {
                    title: "计划数",
                    key: "planQty",
                },
                {
                    title: "销毁数",
                    key: "destroyQty",
                },
                {
                    title: "长*宽*高(cm*cm*cm)",
                    render: (h, { row }) => {
                        return (
                            <div>
                                {row.length} * {row.width} * {row.height}
                            </div>
                        );
                    },
                },
                {
                    title: "重量(g)",
                    key: "weight",
                },
            ];
            if (this.queryType !== "query") {
                // 增加最左侧选框
                columns.unshift({
                    type: "selection",
                    width: 60,
                    align: "center",
                });
                // 编辑、新增时去除销毁数
                columns.splice(5, 1);
            }
            return columns;
        },
        attachColumn() {
            return [
                {
                    type: "selection",
                    width: 60,
                    align: "center",
                },
                {
                    type: "index",
                    title: "No.",
                    width: 60,
                    align: "center",
                },
                {
                    title: "附件类型",
                    key: "attachType",
                },
                {
                    title: "附件名称",
                    key: "filename",
                },
                {
                    title: "附件链接",
                    key: "fileurl",
                },
                {
                    title: "创建时间",
                    key: "createdAt",
                },
            ];
        },
        logColumn() {
            return [
                {
                    type: "index",
                    title: "No.",
                    width: 60,
                    align: "center",
                },
                {
                    title: "操作类型",
                    // width: 100,
                    render: (h, { row }) => {
                        let label = this.operateTypeList.filter((item) => {
                            return item.value === row.operateType;
                        })[0].label;
                        return <div>{label}</div>;
                    },
                },
                {
                    title: "操作人",
                    key: "updatedName",
                    // width: 100,
                },
                {
                    title: "备注",
                    key: "remark",
                },
                {
                    title: "操作时间",
                    key: "updatedAt",
                    width: 200,
                },
            ];
        },
    },
    methods: {
        /**
         * 重推仓库
         */
        async pushAgain () {
            this.loading = true
            await HttpPushWarehouse({
                id: this.orderId
            }).then(res => {
                this.getLog()
                this.$VMessage.success(res.message)
            }, err =>{
                this.$VMessage.error(err.message)
            }).finally(() => {
                this.loading = false
            })
        },
        /**
         * 导入文件
         */
        importFile() {
            /* if (!this.baseInfo.lineId)
                return this.$VMessage.warning("请先选择项目"); */
            this.modalProps = {
                show: true,
                title: "导入",
                component: "compMutiUpload",
                showFooter: false,
                width: 600,
                props: {
                    ...this.getFileProps,
                },
                on: {
                    "on-cancel": () => {
                        this.modalProps.show = false;
                    },
                    "on-success": this.handleImportData,
                },
            };
        },
        /**
         * 处理导入数据
         */
        async handleImportData(res) {
            try {
                this.modalProps.show = false;
                this.loading = true;
                let allOld = true;
                console.log(res.length)
                for (let i = 0; i < res.length; i++) {
                    console.log(res[i])
                    let productData =res[i];
                    let needNew = true;
                    this.productList.map((item, index) => {
                        if (item.sku === productData.sku) {
                            needNew = false;
                            item.planQty =
                                parseInt(item.planQty) +
                                parseInt(productData.planQty);
                        }
                    });
                    if(needNew){
                        allOld = false;
                        let item = {};
                        if (res[i]) {
                           item = {
                                ...res[i],
                                productName: `${res[i].productNameEn}(${res[i].productName})`,
                            };
                        this.productList.push(item);
                        } 
                    }
                }
                 if (allOld) {
                    this.updateProductList();
                 }
                this.$refs.productForm.resetFields()
                this.loading = false;
            } catch (err) {
                this.loading = false;
                this.$VMessage.error(err);
            }
            // console.log(importFileList);
        },
        async getAttachList() {
            await HttpGetAttachList({
                orderType: 6000,
                orderId: this.orderId,
            }).then(
                (res) => {
                    this.attachList = res.data;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        /**
         * 操作成功更新
         */
        modalSuccess(refresh) {
            if (!refresh) {
                this.getDetail();
            }
        },
        async getDetail() {
            this.loading = true;
            // 基础信息
            await HttpGetDestoryPlanOne({
                id: this.orderId,
            }).then(
                (res) => {
                    // console.log(res);
                    this.baseInfo = res.data;
                    // console.log(this.baseInfo);
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            await this.getAttachList();
            if (this.queryType === "query") {
                await this.getLog();
            }
            // sku列表
            await HttpGetDestoryPlanProductList({
                destroyPlanOrderId: this.orderId,
            }).then(
                (res) => {
                    console.log(res.data)
                    // console.log(res);
                    this.productList = res.data;
                },
                (err) => {}
            );

            this.loading = false;
        },
        async update(success) {
            let flag = true;
            await this.$refs.formbase.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            if (this.productList.length === 0)
                return this.$VMessage.warning("产品明细不能为空");
            this.loading = true;
            // 新增
            if (this.queryType === "add") {
                await HttpCreateDestoryPlan({
                    ...this.baseInfo,
                    destroyPlanOrderItems: this.productList,
                    orderAttaches: this.attachList,
                }).then(
                    (res) => {
                        if (
                            Object.prototype.toString.call(success) ===
                            "[object Function]"
                        ) {
                            success(res.data);
                        } else {
                            this.$VMessage.success(res.message);
                            this.operateSuccess();
                        }
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            }
            // 编辑
            else {
                await HttpUpdateDesotryPlan({
                    id: this.orderId,
                    ...this.baseInfo,
                    destroyPlanOrderItems: this.productList,
                    orderAttaches: this.attachList,
                }).then(
                    (res) => {
                        if (
                            Object.prototype.toString.call(success) ===
                            "[object Function]"
                        ) {
                            success(res.data);
                        } else {
                            this.$VMessage.success(res.message);
                            this.operateSuccess();
                        }
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            }
            this.loading = false;
        },
        async getLog() {
            await HttpGetDestoryLog({
                page: 1,
                rows: 1000,
                sidx: "id",
                sord: "desc",
                "search[EQ_orderNo]": this.baseInfo.destroyPlanOrderNo,
                "search[EQ_orderType]": 6000,
            }).then(
                (res) => {
                    // console.log(res);
                    this.logList = res.data.content;
                },
                (err) => {
                    this.$VMessage.error(err);
                }
            );
        },
        async delAttach() {
            if (this.attachSelection.length === 0)
                return this.$VMessage.warning("至少选择一条");
            await this.attachSelection.map((item) => {
                HttpDelAttachments({
                    id: item.id,
                }).then(
                    (res) => {
                        for (let i = 0; i < this.attachList.length; ) {
                            if (item.id === this.attachList[i].id) {
                                this.attachList.splice(i, 1);
                            } else {
                                i++;
                            }
                        }
                    },
                    (err) => {
                        return this.$VMessage.error(err.message);
                    }
                );
            });
        },
        /**
         * 附件上传表格修改选中值
         */
        changeSelection(selection) {
            this.attachSelection = selection;
        },
        cancel() {
            if (
                this.$route.name === "destoryPlan" ||
                this.$route.name === "destoryPlanAdmin"
            ) {
                this.$emit("on-close");
            } else {
                if (this.manage == 1) {
                    this.$router.push({
                        name: "destoryPlanAdmin",
                    });
                } else {
                    this.$router.push({
                        name: "destoryPlan",
                    });
                }
            }
        },
        /**
         * 处理按钮操作
         */
        async handleOperate(type) {
            let operate =
                this.operateTypeList.filter((item) => {
                    return item.value === type;
                })[0] || {};
            if (!operate) return;
            operate = operate.label;
            // 提交审核
            if (type === 2) {
                if (this.queryType === "query") {
                    // this.modalShow({
                    //     noCommit: true
                    // }, operate, type);
                    // this.operateSuccess();
                    this.modalProps = {
                        show: true,
                        alert: "success",
                        title: "提交审核",
                        params: { id: this.orderId },
                        ajaxRequest: HttpDestoryPlanSubmit,
                        callback: () => {
                            this.operateSuccess();
                        },
                    };
                }
                // 新增或编辑
                else {
                    this.update(async (data) => {
                        this.modalProps = {
                            show: true,
                            alert: "success",
                            title: "提交审核",
                            params: { id: data.id },
                            ajaxRequest: HttpDestoryPlanSubmit,
                            callback: () => {
                                this.operateSuccess();
                            },
                        };
                    });
                }
            }
            // 撤销审核
            else if (type === 3) {
                this.modalProps = {
                    show: true,
                    alert: "warning",
                    title: "撤销审核",
                    params: { id: this.orderId },
                    ajaxRequest: HttpDestoryPlanCancelCommit,
                    callback: () => {
                        this.getDetail();
                    },
                };
            } else {
                this.modalShow({}, operate, type);
            }
        },
        modalShow(otherParams = {}, title, type, success) {
            this.modalProps = {
                show: true,
                title: title,
                showFooter: false,
                width: 600,
                props: {
                    otherParams,
                    id: this.orderId,
                    type: type,
                    success: success,
                },
                component: "compSubmit",
                "on-cancel": () => {
                    this.modalProps.show = false;
                },
            };
        },
        /**
         * 更新产品列表
         */
        async updateProductList() {
            let obj = {};
            this.productCount.totalCount = 0;
            this.productList.map((item) => {
                obj[item.sku] = item.planQty;
                this.productCount.totalCount += parseInt(item.planQty);
            });
            HttpGetcalculateWeightAndVolume({
                ...obj,
                contextId: this.baseInfo.organizationId
                    ? this.baseInfo.organizationId
                    : global.SYSID,
            }).then(
                (res) => {
                    this.productCount = {
                        ...this.productCount,
                        totalVolume: parseFloat(
                            res.data.totalVolume.toFixed(4)
                        ),
                        totalWeight: parseFloat(
                            res.data.totalWeight.toFixed(4)
                        ),
                    };
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        /**
         * 产品列表增加
         */
        async addProductList(dataItem) {
            if (!dataItem) {
                let flag = true;
                await this.$refs.productForm.validate((valid) => {
                    flag = valid;
                });
                await this.$refs.productForm.validateField('sku', (valid) => {
                    if (!valid) {
                        if (!this.productInfo.sku) {
                            return '请填写必填项'
                        }
                    }
                });

                if (!flag) return;
            }
            let productData = this.productInfo;
            if (dataItem) {
                productData = dataItem;
            }
            if (Number(productData.destroyQty)<1) {
                return this.$VMessage.error('销毁数量只能为正整数');
            }
            // console.log(productData)
            let needNew = true;
            this.productList.map((item, index) => {
                if (item.sku === productData.sku) {
                    needNew = false;
                    item.planQty =
                        parseInt(item.planQty) +
                        parseInt(productData.destroyQty);
                }
            });
            // console.log(needNew)
            // 更新列表
            if (!needNew) {
                this.updateProductList();
                return this.$refs.productForm.resetFields()
                // return this.productInfo = {}
            }
            let size = {};
            let id = dataItem
                ? dataItem.productId
                : this.productInfo.entity.productId;
            // 获取产品长宽高
            await HttpGetProductsOne({
                id: id,
            }).then(
                (res) => {
                    (size.width = res.data.width),
                        (size.height = res.data.height),
                        (size.length = res.data.length),
                        (size.weight = res.data.weight);
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            let item = {};
            if (dataItem) {
                item = {
                    ...dataItem,
                    productName: `${dataItem.productNameEn}(${dataItem.productName})`,
                    ...size,
                };
                this.modalShow.show = false;
            } else {
                item = {
                    ...this.productInfo,
                    productName: `${this.productInfo.entity.productNameEn}(${this.productInfo.entity.productName})`,
                    planQty: this.productInfo.destroyQty,
                    productId: this.productInfo.entity.productId,
                    // weight: size.weight,
                    // height: size.height,
                    // length: size.length,
                    // width: size.width,
                    ...size,
                };
            }
            this.productList.push(item);
            // this.productInfo = {};
            this.$refs.productForm.resetFields()
        },
        // 添加附件
        addAttach() {
            this.modalProps = {
                show: true,
                title: "附件上传",
                component: "compUpload",
                showFooter: false,
                width: 600,
                props: {
                    id: this.orderId,
                },
                on: {
                    "on-cancel": () => {
                        this.modalProps.show = false;
                    },
                    "on-success": (list) => {
                        // console.log(list);
                        this.attachList.push(list[0]);
                        this.modalProps.show = false;
                    },
                },
            };
        },
        // 获取每次选中行的erpsku
        selectChange(selection) {
            // console.log(selection);
            let skuList = selection.map((item) => {
                return item.sku;
            });
            this.selectedIndex = [];
            for (let i = 0; i < this.productList.length; i++) {
                for (let j = 0; j < skuList.length; j++) {
                    if (this.productList[i].sku === skuList[j]) {
                        this.selectedIndex.push(i);
                    }
                }
            }
            // console.log(skuList, this.selectedIndex);
        },
        deleteOne() {
            if (this.selectedIndex.length === 0)
                return this.$VMessage.warning("至少选择一条");
            this.selectedIndex.map((item) => {
                this.productList.splice(item, 1);
            });
        },
        deleteAll() {
            this.modalProps = {
                show: true,
                showConfirm: true,
                title: "清空",
                desc: "确定清空？",
                showFooter: false,
                confirm: () => {
                    this.productList = [];
                    this.modalProps.show = false;
                },
            };
        },
        handleSkuErp() {
            if (
                (!this.baseInfo.inventoryType &&
                    this.baseInfo.inventoryType !== 0) ||
                !this.baseInfo.orgWarehouseId 
            ) {
                return this.$VMessage.warning("请填写销毁仓库、库存类型");
            }
            this.modalProps = {
                show: true,
                title: "SKU",
                component: "compErpsku",
                showFooter: false,
                width: 1000,
                props: {
                    initFormData: {
                        "search[EQ_inventoryType]": this.baseInfo.inventoryType,
                        "search[EQ_orgWarehouseId]":
                            this.orgWarehouseId == 0
                                ? ""
                                : this.baseInfo.orgWarehouseId,
                        lineId: this.baseInfo.lineId,
                        "search[EQ_organizationId]": global.SYSID,
                    },
                },
                on: {
                    "on-data": (row) => {
                        // console.log(row);
                        // this.productInfo.sku = row.sku;
                        this.productInfo.inventoryAvailable =
                            row.inventoryAvailable;
                        this.modalProps.show = false;
                        this.productInfo.entity = {
                            ...row,
                        };
                        this.$set(this.productInfo, 'sku', row.sku)
                    },
                },
            };
        },
        /**
         * 操作成功
         */
        operateSuccess() {
            this.$emit("on-update");
            this.$router.push({
                name: "destoryPlan",
            });
        },
    },
};
</script>

<style>
</style>